import { render, staticRenderFns } from "./AddBusinessPartner.vue?vue&type=template&id=7c4a6d13&scoped=true"
import script from "./AddBusinessPartner.vue?vue&type=script&lang=ts"
export * from "./AddBusinessPartner.vue?vue&type=script&lang=ts"
import style0 from "./AddBusinessPartner.vue?vue&type=style&index=0&id=7c4a6d13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4a6d13",
  null
  
)

export default component.exports